import { useMutation, useQueryClient } from "@tanstack/react-query";
import { adminCampaignsKeys } from "Api/Queries/Admin/useAdminCampaignsQuery";
import { postAdminCampaignsIdRestore } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
};

export const useRestoreCampaignMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, number>({
    mutationFn: processResponseWithApiProblemDetails((id: number) =>
      postAdminCampaignsIdRestore(id),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: adminCampaignsKeys.all,
      });
      onSuccess?.();
    },
    onError,
  });
};
